export const categories = [
    {
        id: 1,
        slug: "/red-lentils",
        name: "Red Lentils Whole",
        desc: "Sun-dried & split — perfect for dals, soups, and purees. High protein, earthy sweetness.",
        content:
            "Red lentils are a nutritious, high-protein pulse widely used in global cuisines for dals, soups, and stews. Grown in the fertile Canadian prairies, our red lentils are carefully harvested, cleaned, and sorted to ensure consistent colour, size, and low breakage. Ideal for export to Asian and other international markets, they offer excellent cooking quality, rich flavour, and a competitive advantage for food processors and retailers seeking premium pulses in bulk.",
        img: "/assets/product/red-lentils-whole-2.png",
        tag: "Best Seller",
    },
    {
        id: 2,
        slug: "/red-split-lentils",
        name: "Red Split Lentils",
        desc: "Quick-cooking split lentils with creamy texture and vibrant orange colour.",
        content:
            "Split red lentils are a versatile, nutrient-rich pulse that cooks quickly and turns into a creamy, vibrant-coloured base for dals, soups, and sauces. Canadian-grown split red lentils are carefully de-husked and polished to remove the outer skin, ensuring a soft texture and attractive bright orange appearance that chefs and home cooks prefer. For international buyers, we offer consistent sizing, low impurities, and reliable supply, making them an excellent choice for brands and food manufacturers looking for premium Canadian pulses in their product lines.",
        img: "/assets/product/red-split-lentils-2.png",
        tag: "Premium",
    },
    {
        id: 3,
        slug: "/green-lentils",
        name: "Green Lentils",
        desc: "Firm texture and rich flavour — ideal for salads, stews, and hearty dishes.",
        content:
            "Green lentils are a firm-textured, nutrient-rich pulse that hold their shape during cooking, making them ideal for salads, stews, and hearty vegetarian dishes. Canadian-grown green lentils are harvested at peak quality and cleaned to ensure low breakage, consistent size, and minimal impurities. For export buyers, they offer excellent shelf life, reliable supply, and versatile culinary use, positioning them as a premium staple for food manufacturers, retailers, and bulk purchasers worldwide.",
        img: "/assets/product/green-lentils.png",
        tag: "Export Grade",
    },
    {
        id: 4,
        slug: "/chickpeas",
        name: "Chickpeas",
        desc: "Protein-rich premium chickpeas sourced from trusted Canadian farms.",
        content:
            "Our premium-quality chickpeas are sourced from trusted Canadian farms known for consistent grading and superior crop standards. Rich in protein, fiber, and essential nutrients, our chickpeas are ideal for a wide range of culinary uses, from traditional dishes to modern food processing. We ensure strict quality control, proper cleaning, and export-grade packaging to meet international market requirements. With reliable supply chains and competitive pricing, we cater to global buyers seeking dependable and high-quality chickpea exports.",
        img: "/assets/product/chickpeas.png",
        tag: "Organic",
    },
    {
        id: 5,
        slug: "/yellow-peas",
        name: "Yellow Peas",
        desc: "Nutritious export-grade peas for flour, protein products, and snacks.",
        content:
            "Canadian yellow peas are grown on the pristine prairies, delivering a vibrant pale-yellow colour, mild slightly nutty flavor, and high protein content (21–26%) that meets rigorous international export standards. These export-grade whole peas are ideal source for dals, flour, plant-based protein products, snacks, and bakery mixes. Sourced from trusted farms and backed by certifications such as Non-GMO, Kosher, Halal, and optional Organic, our yellow peas serve major global markets including India, China, the U.S., and Bangladesh with reliable supply, full export documentation, and custom packaging tailored to buyers’ needs.",
        img: "/assets/product/yellow-peas.png",
        tag: "Top Export",
    },
    {
        id: 6,
        slug: "/yellow-split-peas",
        name: "Yellow Split Peas",
        desc: "Creamy, protein-rich split peas with naturally sweet earthy flavour.",
        content:
            "Golden yellow split lentils, sun-ripened on Canada’s prairies, are polished to a luminous glow and selected for flawless consistency. These premium lentils cook quickly into luxuriously creamy dal, soups, and purees, offering a naturally sweet, earthy flavor and a powerful protein boost. Every batch meets pristine export standards with exceptional purity, spotless cleanliness, and vibrant uniformity, ensuring customers receive premium quality in every serving. Export-ready packaging, full documentation, and reliable supply make them a preferred choice worldwide.",
        img: "/assets/product/yellow-split-peas.png",
        tag: "Premium",
    },
    {
        id: 7,
        slug: "/black-beans",
        name: "Black Beans",
        desc: "Dense, meaty texture with rich earthy flavour for global cuisines.",
        content:
            "Jet-black, shiny black turtle beans with a creamy white interior deliver a dense, meaty texture and a mildly sweet, earthy flavor ideal for Latin American, Caribbean, Mexican, Brazilian, and Cajun cuisines. Packed with plant-based protein, fiber, iron, antioxidants, and B vitamins, they are perfect for soups, stews, burritos, rice dishes, salads, dips, and plant-based foods. Export-grade with high purity standards and reliable global supply, our black beans are packaged for international markets across the Americas, Europe, and Asia.",
        img: "/assets/product/black-beans.png",
        tag: "New",
    },
    {
        id: 8,
        slug: "/flax-seeds",
        name: "Flax Seeds",
        desc: "Omega-3 rich Canadian flax seeds with exceptional export purity.",
        content:
            "Nourished by the fertile soils and pristine climate of Western Canada, our flax seeds represent premium agricultural excellence. Packed with heart-healthy Omega-3s, dietary fiber, and plant protein, our export-quality brown and golden flax varieties undergo rigorous multi-stage cleaning to achieve exceptional purity levels. We guarantee phytosanitary-certified shipments in moisture-resistant packaging designed for long ocean transit, ensuring reliable quality and freshness for international buyers worldwide.",
        img: "/assets/product/flax-seeds.png",
        tag: "Healthy Choice",
    },
    {
        id: 9,
        slug: "/canary-seeds",
        name: "Canary Seeds",
        desc: "High-purity export-quality canary seeds for global pet food industries.",
        content:
            "Sourced directly from the Canadian prairies, our export-quality canary seeds are ideal for international pet food manufacturers and seed blenders. Naturally rich in proteins and healthy fats, they help promote optimal feather quality and vitality in cage birds. Using advanced cleaning and air-sorting technology, we achieve a highly polished seed with exceptional purity. Secure moisture-resistant packaging and phytosanitary-certified shipments ensure freshness and quality at every destination port worldwide.",
        img: "/assets/product/canary-seeds.png",
        tag: "Specialty",
    },
    {
        id: 10,
        slug: "/sunflower-oil",
        name: "Sunflower oil",
        desc: "Nutrient-rich Canadian sunflower oil valued for its clean taste, golden color, and superior cooking versatility.",
        content:
            "Sunflower oil from Canada is known for its purity, quality, and versatility. Produced from carefully selected sunflower seeds, it is a light, healthy cooking oil trusted by households and food businesses around the world. Our sunflower oil is processed with strict quality standards to ensure freshness, consistency, and reliable supply for domestic and international markets",
        img: "/assets/product/sunflower-oil.png",
        tag: "Healthy Choice",
    },
    {
        id: 11,
        slug: "/canola-oil",
        name: "Canola oil",
        desc: "Premium Canadian canola oil known for its heart-friendly profile, high stability, and global food industry applications.",
        content:
            "Canola oil is a heart-healthy cooking oil with low saturated fat and a high smoke point, perfect for sautéing, frying, and baking. Its neutral flavor and rich omega-3 content make it versatile for everyday cooking while supporting cholesterol reduction. Available for export in bulk quantities to meet international demand for premium-grade canola oil.",
        img: "/assets/product/canola-oil.png",
        tag: "Specialty",
    },
];